import { inject, Injectable } from '@angular/core';
import { UserControllerApi } from '../../../api/services/user-controller-api';
import { firstValueFrom } from 'rxjs';
import { LoggerWrapper } from '../logger/logger-wrapper.service';
import { UserGeolocationConsentResponse } from '../../../api/models/user-geolocation-consent-response';
import { GetGeolocConsent$Params } from '../../../api/fn/user-controller/get-geoloc-consent';
import { UpdateGeolocConsents$Params } from '../../../api/fn/user-controller/update-geoloc-consents';

@Injectable({
  providedIn: 'root',
})
export class UserGeolocConsentService {
  private readonly logger = inject(LoggerWrapper);
  private readonly userApi: UserControllerApi = inject(UserControllerApi);

  private currentConsentChrono: boolean = false;

  async getGeolocConsent(userId: string): Promise<UserGeolocationConsentResponse> {
    try {
      const params: GetGeolocConsent$Params = { id_user: userId };
      return await firstValueFrom(this.userApi.getGeolocConsent(params));
    } catch (e) {
      this.logger.error(e, 'getGeolocConsent: Error calling API');
      return Promise.reject(e);
    }
  }

  async updateGeolocConsents(userId: string, geolocationChronoAccepted: boolean): Promise<void> {
    try {
      const params: UpdateGeolocConsents$Params = {
        body: {
          user_id: userId,
          geolocation_chrono_accepted: geolocationChronoAccepted,
        },
      };
      await firstValueFrom(this.userApi.updateGeolocConsents(params));
      this.loadConsent(userId);
    } catch (e) {
      this.logger.error(e, 'updateGeolocConsent: Error calling API');
      return Promise.reject(e);
    }
  }

  loadConsent(userId: string): void {
    this.getGeolocConsent(userId).then((response: UserGeolocationConsentResponse) => {
      this.currentConsentChrono = response.geolocationChronoAccepted;
    });
  }

  getCurrentConsentChrono(): boolean {
    return this.currentConsentChrono;
  }
}
